import { ReactNode, useEffect } from 'react';
import { useDispatcherProfile } from '../dispatcher/DispatcherAPI';
import {
  isCarrierTMSWebView,
  isLoadboardDesktop,
} from 'shared/constants/AppTypeConstants';
import { hideDefaultBotpressFab, useBotpress } from './Botpress';
import { BotpressLauncher } from './BotpressLauncher';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useDriver } from '../../../carrier/drivers/data/DriversAPI';
import { getOS } from 'shared/helpers/BrowserHelpers';
import { useOpenSupportFromURL } from './useOpenSupportFromURL';
import { renderChildren, useResponsiveValue } from '@superdispatch/ui';

const platform = isCarrierTMSWebView
  ? 'Mobile'
  : isLoadboardDesktop
    ? 'Loadboard'
    : 'Carrier';

export function BotpressProvider({ children }: { children: ReactNode }) {
  const isWebview = MobileAppBridge.isInjected();
  const isMobile = useResponsiveValue(true, true, false);
  const { data: dispatcher } = useDispatcherProfile();
  const botpress = useBotpress();
  const driverGuid = MobileAppBridge.getDriverGuid();
  const { data: driver } = useDriver(driverGuid, { enabled: !!driverGuid });

  const name = isWebview ? driver?.name : dispatcher?.name || '';
  const email = isWebview ? driver?.email : dispatcher?.email || '';

  useOpenSupportFromURL();

  useEffect(() => {
    if (!botpress) return;
    return botpress.on('webchat:closed', () => {
      hideDefaultBotpressFab();
    });
  }, [botpress]);

  useEffect(() => {
    if (!email || !botpress) return;

    return botpress.on('webchat:ready', async () => {
      if (!botpress.initialized) return;

      const user = await botpress.getUser();
      const currentName = user.name;

      if (name && currentName !== name) {
        await botpress.updateUser({
          name,
          data: { name, email, platform, os: getOS() },
        });
      }
    });
  }, [email, botpress, name]);

  return (
    <>
      {renderChildren(children)}
      {!isMobile && <BotpressLauncher />}
    </>
  );
}
